import React from 'react';
import { Modal } from 'react-daisyui';
import useGlobalContext from '../hooks/useGlobalContext';

export default function ModalConfirm({ title, message, buttons, input, additionalMessage }) {
  const { modalConfirm, toggleVisibleModalConfirm } = useGlobalContext();
  return (
    <Modal
      className="flex flex-col gap-5 items-center"
      open={modalConfirm}
      onClickBackdrop={toggleVisibleModalConfirm}
    >
      <div className="font-bold text-lg">{title}</div>
      <div className="px-2">{message}</div>
      {input && <div className="w-full">{input}</div>}
      {additionalMessage && <div className='w-full'>{additionalMessage}</div>}
      <div className="w-full">
        <div className="flex justify-evenly">{buttons}</div>
      </div>
    </Modal>
  );
}
